import { useState } from 'react';
import { Link2, Wallet } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PaymentLinkDialog } from '@/components/invoices/PaymentLinkDialog';
import { PispiRtpDialog } from '@/components/invoices/PispiRtpDialog';
import { SourceFileNote } from '@/components/invoices/SourceFileNote';
import { usePosPaymentMethods } from '@/api/queries/ui-preferences';
import type { InvoicePaymentRequestProps, SourceFileNoteProps } from '@efacture/web-billing/billing-host/types';

/**
 * « Demander paiement PI-SPI » and « Lien de paiement en ligne », with their
 * dialogs; neither shows once the company's PI-SPI configuration is known
 * to be disabled.
 */
export function ShellInvoicePaymentRequest({ invoice }: InvoicePaymentRequestProps) {
  const [showPispiDialog, setShowPispiDialog] = useState(false);
  const [showPaymentLinkDialog, setShowPaymentLinkDialog] = useState(false);
  const { data: paymentMethods } = usePosPaymentMethods();
  if (paymentMethods?.pispiEnabled === false) return null;
  return (
    <>
      <Button onClick={() => setShowPispiDialog(true)} variant="outline">
        <Wallet className="w-4 h-4" />
        Demander paiement PI-SPI
      </Button>
      <Button onClick={() => setShowPaymentLinkDialog(true)} variant="outline">
        <Link2 className="w-4 h-4" />
        Lien de paiement en ligne
      </Button>
      <PaymentLinkDialog
        isOpen={showPaymentLinkDialog}
        onClose={() => setShowPaymentLinkDialog(false)}
        invoice={{ id: invoice.id, number: invoice.number }}
      />
      <PispiRtpDialog
        isOpen={showPispiDialog}
        onClose={() => setShowPispiDialog(false)}
        invoice={{
          id: invoice.id,
          number: invoice.number,
          remainingDue: invoice.remainingDue,
          currency: invoice.currency,
          dueDate: undefined,
        }}
      />
    </>
  );
}

/** The file an invoice was created from. */
export function ShellSourceFileNote({ invoiceId, className }: SourceFileNoteProps) {
  return <SourceFileNote kind="invoice" documentId={invoiceId} {...(className !== undefined && { className })} />;
}
